import { selectIsDelegatedManager, useAuthenticationService } from '@/services/authentication/authentication-service';
import { Role } from '@/services/authentication/authentication.types';
import { Location } from '@/services/gql/graphql.generated';
import { useLocationService } from '@/services/location/LocationService';
import { useAdminLocationStore } from '@/services/location/useAdminLocationStore';
import { useCallback } from 'react';

export const useStartManagerDelegation = () => {
  const { selectedLocation, setSelectedLocation } = useLocationService(state => ({
    selectedLocation: state.selectedLocation,
    setSelectedLocation: state.setSelectedLocation
  }));
  const { setActingLocation, setPreviousAdminLocation } = useAdminLocationStore(state => ({
    setActingLocation: state.setActingLocation,
    setPreviousAdminLocation: state.setPreviousAdminLocation
  }));
  const { startDelegation, user, isDelegatedManager } = useAuthenticationService(state => ({
    startDelegation: state.startDelegation,
    user: state.user,
    isDelegatedManager: selectIsDelegatedManager(state)
  }));

  return useCallback(
    async (location: Location) => {
      if (!isDelegatedManager) {
        const targetTenantId = user?.profile?.organisation;
        if (!targetTenantId) {
          throw new Error('Tenant id is missing.');
        }

        setPreviousAdminLocation(selectedLocation);
        await startDelegation(targetTenantId, '', Role.Manager);
      }

      setActingLocation(location);
      setSelectedLocation(location);
    },
    [
      isDelegatedManager,
      selectedLocation,
      setActingLocation,
      setPreviousAdminLocation,
      setSelectedLocation,
      startDelegation,
      user?.profile?.organisation
    ]
  );
};
